import axiosInstance from './Instance/axiosInstance';
import { Order } from '../types/order';

export const fetchOrders = async (): Promise<Order[]> => {
    const res = await axiosInstance.get('/orders');
    return res.data;
};

export const createOrder = async (order: Partial<Order>): Promise<Order> => {
    const res = await axiosInstance.post('/orders', order);
    return res.data;
};

export const updateOrder = async (id: string, order: Partial<Order>): Promise<Order> => {
    const res = await axiosInstance.put(`/orders/${id}`, order);
    return res.data;
};

export const deleteOrder = async (id: string): Promise<void> => {
    await axiosInstance.delete(`/orders/${id}`);
};

export const fetchOrdersByStatus = async (status: string): Promise<Order[]> => {
    const res = await axiosInstance.get(`/orders/status/list/${status}`);
    return res.data;
};

export const updateOrderStatus = async (id: string, status: string) => {
    const response = await axiosInstance.put(`/orders/status/${id}`, { status });
    return response.data;
};

export const downloadOrdersPdf = async (orderIds: string[], lang: string): Promise<Blob> => {
    const res = await axiosInstance.post(
        '/pdf/download-invoice',
        { orderIds, lang },
        { responseType: 'blob' }
    );
    if (res.status < 200 || res.status >= 300) {
        throw new Error('Failed to generate PDF');
    }
    return res.data as Blob;
};